import React from 'react'
import styled from 'styled-components'

import { theme } from '../../../../theme'

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 16px;
`

export const SectionTitle = styled.h3`
  font-weight: ${theme.fontWeight.semiBold};
  font-size: 18px;
`

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const InfoLabel = styled.span`
  font-weight: ${theme.fontWeight.medium};
  color: ${theme.colors.primaryDefault};
`

export const InfoValue = styled.span`
  font-weight: ${theme.fontWeight.light};
  color: ${theme.colors.greyText};
`

export const InfoList = ({
  title,
  dictionary,
}: {
  title: string
  dictionary: { [key: string]: React.ReactNode }
}) => {
  const entries = Object.entries(dictionary)
  if (entries.length === 0) {
    return null
  }

  return (
    <InfoSection>
      <SectionTitle>{title}</SectionTitle>
      {entries
        .map(([key, value]) =>
          !key || !value ? null : (
            <InfoRow key={key}>
              <InfoLabel>{key}</InfoLabel>
              <InfoValue>{value}</InfoValue>
            </InfoRow>
          )
        )
        .filter((v) => v)}
    </InfoSection>
  )
}
